module.exports = __webpack_public_path__ + "img/243.4acef9c6.jpg";